import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { Box, Container } from '@montugroup/design-system';
import { BrandThemeProvider } from '@montugroup/themes';
import { styled } from '@mui/material';
import React from 'react';
import PortalPartnerLayout from './portal-partner-layout/PortalPartnerLayout';

const ContentContainer = styled(Container)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(12),
}));

function UnauthenticatedLayout({ children }: React.PropsWithChildren) {
  const { key: partnerKey, Logo: PartnerLogo } = usePortalPartnerBrand();

  return (
    <BrandThemeProvider theme={partnerKey}>
      <HeaderContainer>
        <PartnerLogo fillColor={(theme) => theme.palette.text.primary} />
      </HeaderContainer>
      <PortalPartnerLayout.Content>
        <ContentContainer>{children}</ContentContainer>
      </PortalPartnerLayout.Content>
    </BrandThemeProvider>
  );
}

export default UnauthenticatedLayout;
